import { Component, Input, ViewChild } from '@angular/core';
import { EmailActivity } from '../../../../../models/activities';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';
import { EmailEditorComponent } from 'src/app/views/admin/email-editor/email-editor.component';

@Component({
  selector: 'wm-email-activity-editor',
  templateUrl: './email-activity-editor.component.html',
  styleUrls: ['./email-activity-editor.component.css'],
  standalone: false
})
export class EmailActivityEditorComponent extends ActivityEditorBaseComponent {
  @ViewChild('emailEditor', { static: false })
  emailEditor: EmailEditorComponent;

  @Input() activity: EmailActivity;
  @Input() loadFull = false;
  @Input() viewInModal = true;
  @Input() showEmailFooterManagementLink = true;
  @Input() hideHeader = false;

  init() {
    this.emailEditor.init();
  }
}
